import config from 'config'
import {
  ActivityDetailAssessor,
  ActivityLogs,
  ActivityOverviewAssessor
} from 'containers/pages'
import React from 'react'
import { get } from 'lodash'

const urlPrefix = `${config.publicPath}/assessor/activity/:activityId`


export default [

  {
    path: `${urlPrefix}`,
    component: props => (
      <ActivityDetailAssessor
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: [
      {
        path: `${urlPrefix}/logs`,
        component: props => (
          <ActivityLogs
            params={get(props, 'match.params', {})}
            {...props}
          />
        ),
        routes: []
      },
      {
        path: `${urlPrefix}/overview`,
        component: props => (
          <ActivityOverviewAssessor
            params={get(props, 'match.params', {})}
            {...props}
          />
        ),
        routes: []
      }
    ]
  }
]
